export default "__VITE_ASSET__10hn_zjI__"